import React from 'react';
import OInput from '../../../UI/FormControls/OInput';
import MyButton from '../../../UI/myButton/MyButton';
import { SABLON_URL } from '../excel/uvozDelova';

const FilterDelova = ({
  searchText,
  setSearchText,
  filterDelova,
  otvoriUvoz,
}) => {
  const handleInputChange = (event) => {
    setSearchText(event.target.value);
  };
  return (
    <div style={{ display: 'flex', gap: '20px', margin: '10px' }}>
      {' '}
      <OInput
        style={{ width: '300px' }}
        label="Search"
        name="partNumber"
        value={searchText}
        handleChange={handleInputChange}
      />
      <MyButton
        onClick={filterDelova}
        label="Filter"
        icon="fa fa-search"
        style={{
          backgroundColor: '#ff7c00',
          color: '#fff',
          border: 'none',
          borderRadius: '10px',
        }}
      />
      <MyButton
        onClick={otvoriUvoz}
        label="Uvoz iz Excela"
        icon="fas fa-file-excel"
        style={{
          backgroundColor: '#ff7c00',
          color: '#fff',
          border: 'none',
          borderRadius: '10px',
        }}
      />
      <MyButton
        onClick={() => window.open(SABLON_URL, '_blank', 'noopener')}
        label="Preuzmi šablon"
        icon="fas fa-download"
        style={{
          backgroundColor: '#ff7c00',
          color: '#fff',
          border: 'none',
          borderRadius: '10px',
        }}
      />
    </div>
  );
};

export default FilterDelova;
